const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || "0oa5sxryl2dJR1ItL1d7";
const ISSUER =
  process.env.REACT_APP_ISSUER ||
  "https://grayassociates.oktapreview.com/oauth2/default";
const OKTA_TESTING_DISABLEHTTPSCHECK =
  process.env.OKTA_TESTING_DISABLEHTTPSCHECK || false;
const REDIRECT_URI = `${window.location.origin}/login/callback`;

// eslint-disable-next-line
export default {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ["openid", "profile", "email"],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
    cookies: {
      secure: true,  
      sameSite: 'none',
    }
  },

};
